import { useState, Fragment } from "react";
import { Button } from "core/components/form-controls";
import BottomSwiper from "core/components/BottomSwiper";
import { _t } from "core/language";
import Icon from 'core/assets/icons';
import { AddIngredientByImageSwiperButton } from 'modules/AiChef/components';

type TAddIngredientSwiperButton = {
  className?: string,
  onAddByList?: () => void,
  size?: string,
}

const AddIngredientSwiperButton = ({
  className,
  onAddByList,
  size
}: TAddIngredientSwiperButton) => {

  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const toggleDrawer = () => {
    setIsDrawerOpen((prevState: boolean) => !prevState);
  };

  const _addByList = () => {
    toggleDrawer()
    setTimeout(() => {
      onAddByList?.()
    }, 100)
  }

  return (
    <Fragment>
      <Button
        label={_t('ingredient.add')}
        onClickBtn={toggleDrawer}
        classBtn={`${className || 'px-[67px]'}`}
        size={size}
      />
      
      <BottomSwiper
        title={_t('ingredient.add_title')}
        isOpen={isDrawerOpen}
        toggleDrawer={toggleDrawer}
        zIndex={50}
      >
        <div className="flex flex-col gap-3">
          <AddIngredientByImageSwiperButton
            className="w-full"
            onOpen={() => setIsDrawerOpen(false)}
            onClose={() => setIsDrawerOpen(true)}
            primary
          />
          <Button
            label={_t('ingredient.add_by_list')}
            classBtn="w-full"
            primary
            outline
            icon={Icon.RecipeSelectByList}
            onClickBtn={_addByList}
          />
        </div>
      </BottomSwiper>
    </Fragment>
  )
}

export default AddIngredientSwiperButton
